var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_wrapper"},[_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]),_c('vue-editor',{ref:"editor",attrs:{"dir":"ltr","id":_vm.name,"editor-options":_vm.toolbarOptions},on:{"text-change":_vm.updateValue},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }